import { styled, css } from 'styled-components'
import COLORS from '@web-ui-kit/colors'
import { ALIGN, POSITION } from './Walkthrough.helper'
import { pxToRem } from 'utils'

const focusPadding = 6

const getPositionCoords = (coords, location) => {
  const gapElementWithFocus = 25
  let left = 0
  let top = 0
  let right = null
  let height = 'auto'

  if (location?.align === ALIGN.START) {
    left = coords?.x - focusPadding - coords?.widthContent - gapElementWithFocus
  }
  if (location?.align === ALIGN.END) {
    left = coords?.right + focusPadding + gapElementWithFocus
  }
  if (location?.align === ALIGN.CENTER) {
    const currentX = coords?.x - focusPadding
    const currentRight = coords?.right + focusPadding
    const center = (currentX + currentRight) / 2
    left = center - coords?.widthContent / 2
  }
  if (
    location?.align === ALIGN.START &&
    location?.position === POSITION.BOTTOM
  ) {
    left = coords?.left - focusPadding
  }
  if (location?.align === ALIGN.END && location?.position === POSITION.BOTTOM) {
    const currentRight = coords?.windowWidth - coords?.right
    right = currentRight - gapElementWithFocus + focusPadding * 3
    left = 'auto'
  }
  if (location?.position === POSITION.TOP) {
    top =
      coords?.top - focusPadding - coords?.heightContent - gapElementWithFocus
  }
  if (location?.position === POSITION.BOTTOM) {
    top = coords?.bottom + focusPadding + gapElementWithFocus
  }
  if (location?.position === POSITION.IN_LINE) {
    top = coords?.top - focusPadding
  }
  if (location?.position === POSITION.CENTER) {
    const currentY = coords?.top - focusPadding
    const currentBottom = coords?.bottom + focusPadding
    const center = (currentY + currentBottom) / 2
    top = center - coords?.heightContent / 2
  }
  if (location?.position === POSITION.TOP && location?.align === ALIGN.START) {
    const currentY = coords?.top - focusPadding
    const currentBottom = coords?.bottom + focusPadding
    const center = (currentY + currentBottom) / 2
    top = center - coords?.heightContent
  }

  if (top + coords.heightContent > coords.windowHeight) {
    const overflow = top + coords.heightContent - coords.windowHeight
    height = coords.heightContent - overflow - gapElementWithFocus
  }
  if (top < 0) {
    const prevTop = -top
    top = gapElementWithFocus
    height = coords.heightContent - gapElementWithFocus - prevTop
  }

  const totalHeight = coords?.heightContent + top
  if (totalHeight > window.innerHeight) {
    const rest = totalHeight - window.innerHeight
    top = top - (rest + gapElementWithFocus)
  }

  return css`
    left: ${`${left}px`};
    top: ${`${top}px`};
    right: ${right ? `${right}px` : ''};
    > div {
      height: ${`${height}px`};
    }
  `
}

export const Overlay = styled.div`
  ${({ $enable }) =>
    !$enable &&
    css`
      background-color: rgb(33 33 33 / 50%);
    `}
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 21;
`

export const Wrapper = styled.section`
  border-radius: 1.25rem;
  max-width: calc(100% - 6rem);
  overflow: hidden;
  position: fixed;
  transition: height 0.5s ease;
  & > div {
    overflow: auto;
    scrollbar-color: ${COLORS.NEUTRAL_300} ${COLORS.WHITE};
  }
  > div {
    border-radius: 0;
  }
  & p {
    margin: 1rem 0;
  }
  & img {
    aspect-ratio: 15/9;
  }

  ${({ $coords, $location }) => {
    return !$coords
      ? css`
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        `
      : css`
          ${getPositionCoords($coords, $location)}
        `
  }}
`

export const Focus = styled.div`
  border-radius: 0.625rem;
  box-shadow: rgb(33 33 33 / 50%) 0 0 0 187.5rem;
  position: fixed;
  ${({ $coords }) => {
    const { height, left, top, width } = $coords || {}

    return css`
      height: ${pxToRem(height + focusPadding * 2)};
      left: ${pxToRem(left - focusPadding)};
      top: ${pxToRem(top - focusPadding)};
      width: ${pxToRem(width + focusPadding * 2)};
    `
  }}
`
